import styled from "styled-components";
import {FaRebel} from 'react-icons/fa'
export const LineAllContent = styled.section`
     background:#111221;
     padding:2rem;
`;
export const LineTitle = styled.h1`
    color:#fff;
    text-align:center;
    font-size:2.5rem;
    @media screen and (max-width:770px){
        font-size:1.5rem !important;
    }
`;
export const LineSbTitleParr = styled.p`
    color:#fff;
    text-align:center;
    margin-top:2rem;
    font-size:1.2rem;
    @media screen and (max-width:770px){
        font-size:1rem !important;
    }
`;
export const LineContainer=styled.section`
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    padding:10px;
    background:#111221;
`;
export const LineContent=styled.div`
    border-left: 2px solid #ddd;
    padding-left: 30px;
    width:80%;
`;
export const LineBox=styled.div`
    width: 100%;
    height:auto !important;
    padding:10px;
    border-radius: 8px;
    background: transparent;
    margin-bottom: 10px;
    font-family:sans-serif;
    position:relative;
    &:before{
        content:'';
        display: block;
        width: 10px;
        height:10px;
        border-radius: 50%;
        background: #000;
        border: 3px solid #ddd;
        position:absolute;
        top: 10px;
        left: -39px;
    }
`;
export const LineSubtile = styled.h2`
    color:#fff;
    font-style:italic;
`;
export const LineLocation = styled.span`
    color:#e8175d;
    font-style:italic;
`;
export const LineDate = styled.span`
    color:#e8175d;
    font-style:italic;
`;
export const LineJob = styled.h3`
    color:#fff;
    margin-top:0.5rem;
`;
export const LineParra = styled.p`
    color:#ccc;
    margin-bottom:0.5rem;
`;
export const LineIcon = styled(FaRebel)`
    margin-left:1rem;
    font-size:1rem;
    color: ${({strong}) => (strong ? '#ccc':'transparent' )};
`;
export const LineIcono = styled(FaRebel)`
    font-size:1.2rem;
    color: #ccc;
`;